export enum CertificationTypeFilter {
    Valid = 1,
    Expired = 2,
}
